import { BlogAPI } from '../../../../../apis/BlogAPI'
import BlogSection from '../../../../../components/BlogSection'
import BlogWrapper from '../../../../../components/BlogWrapper'
import { getBlogWrapperPosts } from '../../../../../helpers/blog'

export async function getStaticPaths() {
    const { data: categories } = await BlogAPI.safeRequest(
        () => BlogAPI.getCategories(),
        { data: [] },
        'category page getStaticPaths',
    )

    const paths = await Promise.all(
        categories.flatMap(async (category) => {
            const { headers } = await BlogAPI.safeRequest(
                () => BlogAPI.getBlogPostsByCategoryId(category.id, 1),
                { headers: { 'x-wp-totalpages': '0' } },
                `category page getStaticPaths posts ${category.slug}`,
            )
            const totalPages = parseInt(headers['x-wp-totalpages'], 10)
            const _paths = Array.from({ length: totalPages }, (_, i) => ({
                params: { slug: category.slug, page: `${i + 1}` },
            }))
            return _paths
        }),
    )

    return { paths: paths.flat(), fallback: 'blocking' }
}

export async function getStaticProps({ params }) {
    const { slug, page } = params

    const pageNumber = parseInt(page, 10)
    const { data: category } = await BlogAPI.safeRequest(
        () => BlogAPI.getCategoryBySlug(slug),
        { data: [] },
        `category page getCategoryBySlug ${slug}`,
    )
    const categoryId = category[0]?.id
    const categoryName = category[0]?.name

    if (!categoryId || !categoryName) return { notFound: true, revalidate: 10 }

    const { data: posts, headers } = await BlogAPI.safeRequest(
        () => BlogAPI.getBlogPostsByCategoryId(categoryId, pageNumber),
        { data: [], headers: { 'x-wp-totalpages': '0' } },
        `category page getBlogPostsByCategoryId ${slug} ${pageNumber}`,
    )

    const { initialCategories, latestBlogPosts, tags, popularPosts } =
        await getBlogWrapperPosts()

    const totalPages = parseInt(headers['x-wp-totalpages'], 10)

    return {
        props: {
            initialPosts: posts,
            initialCategories,
            latestBlogPosts,
            tags,
            popularPosts,
            initialTotalPages: totalPages,
            initialPage: pageNumber,
            categorySlug: slug,
            categoryName: categoryName,
        },
        revalidate: 10, // In seconds
    }
}

export default function CategoryPage({
    initialPosts,
    initialCategories,
    initialTotalPages,
    initialPage,
    latestBlogPosts,
    tags,
    popularPosts,
    categorySlug,
    categoryName,
}) {
    const title = categoryName ? `Category: ${categoryName}` : 'Category'

    return (
        <BlogWrapper
            {...{
                title,
                latestBlogPosts,
                initialCategories,
                tags,
                popularPosts,
            }}>
            <BlogSection
                initialPage={initialPage}
                initialPosts={initialPosts}
                initialCategories={initialCategories}
                initialTotalPages={initialTotalPages}
                categorySlug={categorySlug}
                paginationPrefix={`/category/${categorySlug}`}
                pageTitle={`Category: ${categoryName}`}
            />
        </BlogWrapper>
    )
}
